import React from 'react';
import { IconFill, IconProps } from './IconTemplate';

import { ReactComponent as Icon } from '@assets/icons/arrow-forward.svg';

export default function ArrowForwardIcon(props: IconProps) {
  return <IconFill icon={Icon} {...props} />;
}
